import { ValidationRuleset } from 'vuelidate';
import { User } from '@/store/models';
import { email, minLength, required, sameAs } from 'vuelidate/lib/validators';

export type TManager = { user: User; validationGroup: string[] };

const existsEmail = () => {
  return true;
};

export const managerValidator: ValidationRuleset<TManager> = {
  user: {
    initialPassword: {
      // required,
      // minLength: minLength(6)
    },
    email: {
      required,
      email,
      existsEmail
    },
    firstName: {
      required
    },
    lastName: {
      required
    },
    companyName: {
      required
    },
    jobTitle: {
      required
    }
  }
};
